(window.CollectionSlider = function (Behaviors) {

  "use strict";
  
  function CollectionSlider(elem) {
    Behaviors.init(CollectionSlider, this, arguments)

    this.cSlider = this.$elem[0];

    if (window.innerWidth > 1024) {
      const cSlider = new Swiper(this.cSlider, {
        wrapperClass: 'lb-slider__track',
        slideClass: 'lb-slide',
        mousewheel: {
          releaseOnEdges: true
        },
        speed: 500,
        breakpoints: {
          // when window width is >= 1025px
          1025: {
            slidesPerView: 'auto',
            spaceBetween: 15,
            loop: false,
          }
        }
      });
    }
  }

  Behaviors.inherit(CollectionSlider, Behaviors.Behavior);
  CollectionSlider.QUERY = '.lb-slider';

  Behaviors.register_behavior(CollectionSlider);
  
  return CollectionSlider;

  }(window.Behaviors));